import { QueryFunctionContext, useQuery, UseQueryResult } from "@tanstack/react-query";
import { configuration } from "../../../configuration";
import { FetchError, GetOneOnOneMeetingDto } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";
import { GetTeamMeetingDto } from "../../types/meetings/GetTeamMeetingDto";

const useGetMeetingRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getMeetingRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.meetings.getMeeting>>): Promise<
    GetOneOnOneMeetingDto | GetTeamMeetingDto
  > {
    const accessToken = await getAccessToken();
    const [{ meetingGuid }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/meetings/${meetingGuid}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getMeetingRequest };
};

const useGetMeeting = (meetingGuid: string, enabled?: boolean) => {
  const { getMeetingRequest } = useGetMeetingRequest();

  return useQuery({
    queryKey: queryKeys.meetings.getMeeting(meetingGuid),
    queryFn: getMeetingRequest,
    enabled: enabled,
    cacheTime: 0,
  });
};

const useGetOneOnOneMeeting = (meetingGuid: string, enabled?: boolean) => {
  return useGetMeeting(meetingGuid, enabled) as UseQueryResult<GetOneOnOneMeetingDto>;
};

const useGetTeamMeeting = (meetingGuid: string, enabled?: boolean) => {
  return useGetMeeting(meetingGuid, enabled) as UseQueryResult<GetTeamMeetingDto>;
};

export { useGetMeeting, useGetOneOnOneMeeting, useGetTeamMeeting };
